import React from "react";
import { Input } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const CodeInput = ({ checking, onChangeCode }) => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Input.OTP
      disabled={checking}
      size="large"
      variant="filled"
      className="custom-otp"
      onChange={onChangeCode}
      inputMode="numeric"
      pattern="[0-9]*"
    />
  );
};
export default CodeInput;
